import pagesNames from "../../constants/pages-names";

const navListAr = [
    {
        buttonId : "button-our-esg-strategy",
        title : "استراتجيتنا",
        path : pagesNames.starategy,
        submenu : {
            id : "submenu-our-esg-strategy",
            nextId : "submenu-our-comitments",
            title : "استراتيجيتنا للممارسات البيئية والاجتماعية والحوكمة المؤسسية",
            subtitle : "نضطلع بدور رائد في حشد التمويل بهدف دعم مسيرة التحول مع مراعاة الشمولية والتنوع والإنصاف نحو اقتصاد أكثر استدامة.",
            button : {
                text : "أقرأ المزيد",
                path : pagesNames.starategy,
            },
            list : [
                {
                    text : "القضايا الجوهرية بالنسبة لبنك الأول",
                    path : pagesNames.materials,
                },
                {
                    text : "الأثر البيئي",
                    path : pagesNames.environment,
                },
                {
                    text : "الأثر الاجتماعي",
                    path : pagesNames.social,
                },
                {
                    text : "الحوكمة",
                    path : pagesNames.governance,
                },
                {
                    text : "استراتيجية أعمالنا",
                    path : pagesNames.business,
                },
                {
                    text : "إدارة المخاطر",
                    path : pagesNames.risk,
                }
            ],
            image : {
                name : 'strategy.jpg',
                alt : "Arabian Woman"
            },
        },
    },
    {
        buttonId : "button-our-comitments",
        title : "التزاماتنا",
        // path : `/${siteLinks.ourCommitments}`,
        path : pagesNames.commitments,
        submenu : {
            id : "submenu-our-comitments",
            nextId : "submenu-our-esg-journey",
            title : "التزاماتنا",
            subtitle : "يفخر الأول بالمساهمات التي يقدمها في سبيل تحقيق أهداف رؤية السعودية 2030، حيث نرصد جزءاً من ميزانيتنا العمومية لتمويل التحوّل إلى الاستدامة.",
            button : {
                text : "أقرأ المزيد",
                // path : `/${siteLinks.ourCommitments}`,
                path : pagesNames.commitments,
            },
            list : [
                {
                    text : "التحول لعمليات خالية من الانبعاثات",
                    path : pagesNames.transition,
                },
                {
                    text : "الطاقة والانبعاثات",
                    path : pagesNames.emissions,
                },
                {
                    text : "مبادرة السعودية الخضراء",
                    path : pagesNames.saudiGreen,
                },
                {
                    text : "رؤية السعودية 2030",
                    path : pagesNames.vision,
                },
                {
                    text : "منتجات وخدمات مستدامة",
                    path : pagesNames.sustainableFinancing,
                },
            ],
            image : {
                name : "commitments.jpg",
                alt : "Our Commitments background"
            },
        },
    },
    {
        buttonId : "button-our-esg-journey",
        title : "رحلتنا",
        // path : `/${siteLinks.ourJourney}`,
        path : pagesNames.journey,
        submenu : {
            id : "submenu-our-esg-journey",
            title : "رحلتنا في مجال الممارسات البيئية والاجتماعية والحوكمة المؤسسية.",
            subtitle : "نسعى لبلوغ أهدافنا في هذا المجال عن طريق ترسيخ الممارسات البيئية والاجتماعية والحوكمة المؤسسية في قلب أنشطة البنك وأعماله ومن خلال الاستعانة بشراكتنا مع إتش إس بي سي.",
            button : {
                text : "اقرأ المزيد",
                // path : `/${siteLinks.ourJourney}`,
                path : pagesNames.journey,
            },
            list : [
                {
                    text : "أبرز النقاط 2022",
                    path : pagesNames.highlight,
                },
                {
                    text : "اعتماد الممارسات البيئية والاجتماعية والحوكمة المؤسسية في جميع قطاعات الأعمال بالبنك",
                    path : pagesNames.embedding,
                },
                {
                    text : "أطر العمل الدولية ",
                    path : pagesNames.frameworks,
                },
                {
                    text : "نصغي باهتمام لأصحـاب المصلحة",
                    path : pagesNames.stakeholders,
                },
            ],
            image : {
                name : "journey.jpg",
                alt : "Journey page menu image"
            },
        },
    },
    {
        buttonId : "button-news",
        title : "الأخبار",
        // path : `/${siteLinks.news}`,
        path : pagesNames.news,
        submenu : null,
    },
    {
        buttonId : "button-insights",
        title : "الرؤى",
        // path : `/${siteLinks.insights}`,
        path : pagesNames.insight,
        submenu : null,
    },
    {
        buttonId : "button-statements-and-plicies",
        title : "البيانات والسياسات",
        id : "submenu-statements-and-plicies",
        // path : `/${siteLinks.statements}`,
        path : pagesNames.statements,
        submenu : {
            title : "البيانات والسياسات",
            subtitle : "تدرك مؤسستنا مدى أهمية تناول قضايا الاستدامة والممارسات البيئية والاجتماعية والحوكمة المؤسسية التي لتنال قسطًا هائلاً من اهتمام عملائنا والمتعاملين معنا ومستثمرينا وغيرهم من أصحاب المصلحة. وحرصًا منا على ضمان الاتساق في أنشطة الحوكمة في هذه القضايا، فقد وضعنا مجموعة من السياسات وبيانات النوايا التي تنطبق على جميع المستويات بالمؤسسة وأوردناها بالتفصيل في هذه الصفحة.",
            button : {
                text : "إقرأ المزيد",
                // path : `/${siteLinks.statements}`,
                path : pagesNames.statements,
            },
            list : [
                {
                    text : "سياسة المسؤولية الاجتماعية لبنك الأول",
                    path : pagesNames.csr,
                },
                {
                    text : "الامتثال للقوانين والأنظمة",
                    path : pagesNames.compliance,
                }
            ],
            image : {
                name : "statements.jpg",
                alt : "Statements and Polices menu wallpaper"
            },
        },
    },
    {
        buttonId : "button-esg-resource-hub",
        title : "محور الموارد",
        // path : `/${siteLinks.resource}`,
        path : pagesNames.resource,
        submenu : {
            id : "submenu-esg-resource-hub",
            title : "محور الموارد في قضية الممارسات البيئية والاجتماعية والحوكمة المؤسسية",
            subtitle : "تزامنًا مع تطور معايير إعداد التقارير واتساع رقعة تطبيقها على مستوى العالم، فقد كنا ولا نزال ملتزمين بتكييف نهجنا في التعامل مع الممارسات البيئية والاجتماعية والحوكمة المؤسسية وفق الإرشادات التوجيهية التنظيمية والأعراف المتبعة بالقطاعات التي نعمل بها.",
            button : {
                text : "إقرأ المزيد",
                // path : `/${siteLinks.resource}`,
                path : pagesNames.resource,
            },
            list : [
                {
                    text : "التقارير",
                    path : pagesNames.reports,
                },
                {
                    text : "ملف الممارسات البيئية والاجتماعية والحوكمة المؤسسية",
                    path : pagesNames.esgProfile,
                },
            ],
            image : {
                name : "resource.jpg",
                alt : "ESG Resource hub wallpaper",
            },
        },
    },
]

export default navListAr;